import { AdminTemplate, MerchantEndOfDayComponentWithBalance } from "../../../components";

export const MerchantEndOfDayWithBalance = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "İşyeri Hak Ediş Raporları",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,

      }}
      showHeaderTitle={true}>
      <MerchantEndOfDayComponentWithBalance />
    </AdminTemplate>
  );
};
